import React, { useState, useContext } from "react";
import { Box, Typography, CircularProgress, List, ListItem, TextField, useMediaQuery, useTheme } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import { ThemeContext } from "../../../context/ThemeContext";
import PullToRefresh from 'react-pull-to-refresh';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getNews } from "../../../api/request/dashboard/dashboard";
import { setNews } from "../../../store/Slices/newsSlice";

export default function News({ searchQuery: externalSearchQuery }) {
  const { darkMode } = useContext(ThemeContext);
  const [searchQuery, setSearchQuery] = useState(externalSearchQuery || "");
  const { news = [] } = useSelector((state) => state.news);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const activeSearch = typeof externalSearchQuery === "string" ? externalSearchQuery : searchQuery;
  const imgSrc = darkMode ? '/hs-white.png' : '/hs-logo.png'

  const handleRefresh = async () => {
    setIsRefreshing(true); // Start refresh loading
    try {
      const response = await getNews();
      dispatch(setNews(response.data)); // Update Redux store with new news
    } catch (error) {
      console.error("Error fetching news:", error);
    }
    setIsRefreshing(false); // Stop refresh loading
  };

  if (isRefreshing) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="20vh"><CircularProgress /></Box>
    );
  }

  if (!news || news.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Typography variant="h6">{t('nonewsavailable')}</Typography>
      </Box>
    );
  }

  const handleReadMore = (link) => {
    window.open(link, "_blank");
  };

  const filteredNews = news.filter(news =>
  (news.title.toLowerCase().includes(activeSearch.toLowerCase()) ||
    news.newsProviderName.toLowerCase().includes(activeSearch.toLowerCase()))
  );


  return (
    <>
      <Box p={0} sx={{ position: 'relative', height: "calc(100% - 35px)", display: 'flex', flexDirection: 'column' }}>

        <Box sx={{ height: '100%', flex: 1, overflow: 'auto', paddingTop: 1, paddingBottom: isMobile ? 8 : 0 }}>
          <PullToRefresh onRefresh={handleRefresh}>
            <List>
              {filteredNews.map((news) => (
                <ListItem key={news.id} sx={{ marginBottom: 1, borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, paddingBottom: 1 }}>
                  <Box onClick={() => handleReadMore(news.link)}>
                    <Typography variant="body2" sx={{ display: "flex", alignItems: "center", marginBottom: 1, color: darkMode ? "var(--lightText)" : 'var(--darkText)', }}>{news.title}</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }} >
                      <AccessTimeIcon sx={{ marginRight: 1, fontSize: "13px", color: darkMode ? "var(--lightText)" : 'var(--darkText)', }} />
                      <Typography color="textSecondary" sx={{ marginRight: 2, fontSize: "12px" }} > {new Date(news.dateTime).toLocaleString()}</Typography>
                      <PersonIcon sx={{ marginRight: 1, fontSize: "14px", color: darkMode ? "var(--lightText)" : 'var(--darkText)', }} />
                      <Typography color="textSecondary" sx={{ marginRight: 2, fontSize: "12px" }}> {news.newsProviderName}</Typography>
                    </Box>
                  </Box>
                </ListItem>
              ))}
            </List>
          </PullToRefresh>
        </Box>
      </Box>
      <div style={{ height: 35, borderTop: '1px solid rgba(0, 0, 0, 0.3)' }}>
        <div className='flex items-center px-1 justify-between' style={{ marginTop: 3, marginLeft: 5 }}>
          <TextField size="small" variant="outlined" placeholder={t("mobSearch")} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ width: '250px' }} InputProps={{ sx: { fontSize: 13, padding: 0, height: 30, "& input": { padding: "0", paddingLeft: 1, height: "30px", }, }, }} />
          <div className='flex items-center opacity-50'>
            <small>{t('poweredby')} </small><a href="https://hybridsolutions.com/" target='_blank'><img src={imgSrc} alt="hs" style={{ height: darkMode ? 40 : 20 }} className='ms-2' />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

